import { render, staticRenderFns } from "./fdle.vue?vue&type=template&id=08dd0868&"
import script from "./fdle.vue?vue&type=script&lang=js&"
export * from "./fdle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports